<template>
  <Modal
    width="496"
    v-model.trim="cForm.modal"
    :title="cForm.id ? '编辑' : '新增'"
    :loading="cForm.loading"
    @on-ok="submit"
  >
    <Form
      class="c-form c-form--modal"
      ref="form"
      :model="cForm.model"
      :rules="cForm.rules"
      :label-width="80"
    >
      <Form-item label="画展标题" prop="title">
        <Input
          class="c-form__input"
          v-model.trim="cForm.model.title"
          placeholder="请输入标题"
        />
      </Form-item>
      <Form-item label="封面" prop="image">
        <c-uploader
          class="c-form__input"
          :key="`logo-${cForm.id}`"
          :default-file-ids="cForm.model.image"
          @change="
            value => {
              handleFormUploaderChange('image', value);
            }
          "
        />
      </Form-item>

      <Form-item label="投票开始时间" prop="startAt_v">
        <DatePicker 
          type="datetime" 
          v-model.trim="cForm.model.startAt_v"
          placeholder="请输入开始时间" 
        ></DatePicker>
      </Form-item>

       <Form-item label="投票结束时间" prop="endAt_v">
        <DatePicker 
          type="datetime" 
          v-model.trim="cForm.model.endAt_v"
          placeholder="请输入结束时间" 
        ></DatePicker>
      </Form-item>
      
      <Form-item label="状态" prop="status">
        <Select
          class="c-form__input"
          placeholder="请选择状态"
          clearable
          v-model="cForm.model.status"
        >
          <Option
            v-for="item in dicts.PublishStatus"
            :key="item.value"
            :value="item.value"
            :label="item.label"
            >{{ item.label }}
          </Option>
        </Select>
      </Form-item>
    </Form>
  </Modal>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import FormMixin from "view-ui-admin/src/mixins/form";

const module = "artshow";

@Component({
  mixins: [FormMixin]
})
export default class BrandsListForm extends Vue {
  data() {
    return {
      cForm: {
        id: 0,
        modal: false,
        loading: true,
        model: this.getFormInitModel(),
        rules: {
          title: [
            {
              required: true,
              message: "名称不能为空"
            }
          ],
          startAt_v: [
            {
              required: true,
              message: "开始时间不能为空"
            }
          ],
          endAt_v: [
            {
              required: true,
              message: "结束时间不能为空"
            }
          ],
          image: [
            {
              required: true,
              message: "封面不能为空"
            }
          ]
        }
      }
    };
  }

  getFormInitModel() {
    return {
      status: 1
    };
  }

  show(detail) {
    this.cForm.modal = true;

    if (detail && detail.id) {
      this.cForm.id = detail.id;
      detail.startAt_v = this.$dayjs(Number(detail.startAt) * 1000).format('YYYY-MM-DD HH:mm:ss');
      detail.endAt_v = this.$dayjs(Number(detail.endAt) * 1000).format('YYYY-MM-DD HH:mm:ss');
      this.initFormFields(detail);
    } else {
      this.cForm.id = 0;
    }
  }

  submit() {
    this.$refs.form.validate(async valid => {
      if (valid) {
        const { id, model } = this.cForm;

        model.startAt = this.$dayjs(model.startAt_v).unix();
        model.endAt = this.$dayjs(model.endAt_v).unix();

        const { data } = await this.$store.dispatch(
          `${module}/${id ? "put" : "post"}`,
          {
            id,
            body: model
          }
        );

        this.cForm.modal = false;
        this.$Message.success(`${id ? "编辑" : "新增"}成功`);
        this.$emit("get-list", data);
      }

      this.fixFormButtonLoading();
    });
  }
}
</script>
